<template>
  <div>

    <section>
      <div class="row">
        <div class="col-xs-12 col-lg-6">
          <div class="row">
            <div class="col-12"><b>In The Media</b></div>
            <div class="col-xs-12 col-md-4"><div class="btn active">News (123)</div></div>
            <div class="col-xs-12 col-md-4"><div class="btn btn-default">Scientific Blogs (123)</div></div>
            <div class="col-xs-12 col-md-4"><div class="btn btn-default">Google+ (123)</div></div>
            <div class="col-12">
              <p><a href="">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.</a></p>
              <p><a href="">Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.</a></p>
              <p><a href="">Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</a></p>
              <p><a href="">Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget.</a></p>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-lg-6">
          <div class="row">
            <div class="col-12"><b>Citations:</b></div>
            <div class="col-xs-12 col-sm-6"><div class="img h1"></div></div>
            <div class="col-xs-12 col-sm-6"><div class="img h1"></div></div>
            <div class="col-xs-12 col-sm-6"><div class="img h1"></div></div>
            <div class="col-xs-12 col-sm-6"><div class="img h1"></div></div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="row">
        <div class="col-6"><b>Social Attention:</b></div>
        <div class="col-6 text-right"><b>29,876</b> Total Shares</div>
        <div class="col-xs-12 col-md-3 col-lg-3">
          <div class="img h1"></div>
          <div class="img h1"></div>
          <div class="img h1"></div>
        </div>
        <div class="col-xs-12 col-md-9"><div class="img h3"></div></div>
      </div>
    </section>

  </div>
</template>


<script>
  export default {
    name: 'media',
    data () {
      return {
      }
    },
    created () {
      this.$parent.$parent.prevPage = {name: 'article-interact'}
      this.$parent.$parent.nextPage = false
      this.$parent.$parent.prevSlide = false
      this.$parent.$parent.nextSlide = {name: 'article-media-news'}
    }
  }
</script>


<style scoped lang="scss">
  .title {
    color: $primary-color;
    font-size: 32px;
  }
  section {
    margin: 20px auto;
    padding-bottom: 12px;
  &:not(:last-child) {
     border-bottom: 1px solid #cccccc;
   }
  p {
    font-size: 14px;
    text-decoration: underline;
    color: $grey-font;
  }
  .text-right {
    font-size: 12px;
    line-height: 24px;
    font-style: italic;
  }
  .img {
    border: 1px solid #cccccc;
    background-color: #eeeeee;
    width: 100%;
  &.h1 {
     height: 160px;
   }
  &.h2 {
     height: calc(320px + 0.5rem);
   }
  &.h3 {
     height: calc(480px + 1rem);
   }
  }
  .btn {
    padding: 10px;
    border: 1px solid #dfdfdf;
    width: 100%;
    text-align: center;
    font-size: 12px;
    margin-bottom: 10px;
  &.active {
     background-color: #cccccc;
   }
  }
  }
</style>



// WEBPACK FOOTER //
// MediaPage.vue?4364b1f4